<template lang="html">

  <section class="wrapper cv-area">

    <div class="container">


      <h2 class="title-section">
        <span @click="toggleEdit">{{(isEstudiante) ? 'Experiencia profesional' : 'Datos profesionales'}}</span>
        <template v-if="!noedit">
          <button @click="showedit= true" class="cv-action-button edit"
            v-if="!showedit"></button>
          <button @click="showedit= false" class="cv-action-button close" v-else>✕</button>
        </template>
      </h2>

      <div class="contenedor-datos row-start ais" v-if="!showedit & !!cvprofesionales & !!rawdominios">

        <template v-if="isAlumni | (noedit && (generales.idActividad | generales.idSector))">
          <p class="dato"><strong>Sector:</strong> {{(!!generales.idSector) ? rawdominios.sectoresActividad[generales.idSector] : 'No definido' }}</p>
          <p class="dato"><strong>Actividad:</strong>
            {{(!!generales.idActividad) ? rawdominios.actividadesProfesionales[generales.idActividad] : 'No definido' }}</p>
        </template>

        <p class="dato" v-if="isEstudiante | (noedit && generales.otraExperiencia)">
          {{generales.otraExperiencia}}
          <template v-if="!!!generales.otraExperiencia">No tienes la experiencia profesional definida, pulsa en <a @click="showedit= true">editar</a> para añadirla</template>
        </p>

      </div>

      <div class="contenedor-datos -edicion row-start ais" v-if="showedit && dominios"
        :edit="showedit">

        <div class="contenedor-input" v-if="isAlumni">
          <label>Sector</label>
          <select name="sector" v-model="generales.idSector">
            <option :value="null">Selecciona tu sector</option>
            <option :value="sector[0]" v-for="sector in
              dominios.sectoresActividad">{{sector[1]}}</option>
          </select>
        </div>

        <div class="contenedor-input" v-if="isAlumni">
          <label>Actividad</label>
          <select name="actividad" v-model="generales.idActividad">
            <option :value="null">Selecciona tu actividad</option>
            <option :value="actividad[0]" v-for="actividad in
              dominios.actividadesProfesionales">{{actividad[1]}}</option>
          </select>
        </div>

        <div class="contenedor-input" v-if="isEstudiante">
          <label>Experiencia profesional</label>
          <textarea name="experienciaprofesional"
            v-model="generales.otraExperiencia"></textarea>
        </div>


        <div class="contenedor-boton">
          <button @click="sendGenerales" :loading="loadingGenerales"
            class="btn">Guardar</button>
        </div>

      </div>

      <template v-if="isAlumni || (noedit && cvprofesionales.experiencia)">

        <h3 class="subtitle-section mt">Experiencia profesional</h3>

        <div class="contenedor-experiencias" v-if="!!cvprofesionales">

          <template v-if="!showedit">
            <experiencia v-if="!!cvprofesionales.experiencia" :data="experiencia" :key="key" v-for="(experiencia,key)
              in cvprofesionales.experiencia" :clicked="clicked"></experiencia>
            <p v-if="!!!cvprofesionales.experiencia && !noedit">No hay experiencias añadidas pulsa <a @click="showedit= true">editar</a> para añadirlas.</p>
          </template>
          
          <template v-if="showedit">
            <experiencia-edit @erase="eraseExperiencia" :data="experiencia" v-model="experienciaedit[key]" :key="key" v-for="(experiencia,key) in cvprofesionales.experiencia"></experiencia-edit>
            <experiencia-edit :clicked="clicked" @erase="eraseNewExperiencia" v-model="newexperiencias[el-1]" v-if="newexperienciaslength != 0" :key="'new-'+key" v-for="(el,key) in newexperienciaslength"></experiencia-edit>
            <button v-if="!shownew" @click="newexperienciaslength++" class="add-btn
            -newexperiencia">Añadir nueva experiencia</button>
          </template>
        </div>
        
        <button class="btn" v-if="showedit" @click="saveData" :loading="loadingExperiencia">Guardar</button>
        
      </template>
      
      <p v-if="!!!cvprofesionales.experiencia && noedit">No hay experiencias añadidas.</p>

    </div>

  </section>


</template>

<script lang="js">

  import experiencia from '@/components/parts/experiencia-el';
  import experienciaedit from '@/components/parts/experiencia-edit';

  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'datos-profesionales',
    props : ['cvprofesionales','noedit'],
    mounted(){
      for(let i in this.generales){
        this.generales[i] = this.cvprofesionales[i];
      }
      this.experienciaedit = (!!this.cvprofesionales.experiencia) ? this.cvprofesionales.experiencia : [];
    },
    data() {
      return {
        showedit: false,
        shownew: false,
        newexperiencias : [],
        newexperienciaslength : 0,
        loadingGenerales : false,
        experienciaedit : [],
        loadingExperiencia: false,
        clicked : false,
        generales : {
          idSector: 0,
          idActividad: 0,
          otraExperiencia: ""
        }
      }
    },
    computed : {
      ...mapGetters({
        dominios : 'getDominiosOrder',
        rawdominios : 'getDominios',
        isEstudiante : 'isEstudiante',
        isAlumni : 'isAlumni'
      })
    },
    methods: {
      ...mapActions(['editProfesionalesGenerales','editExperiencia','requestCV']),
      toggleEdit(){
        if(!this.noedit){
          this.showedit= !this.showedit
        }
      },
      send() {
        this.showedit = false;
      },
      sendGenerales(){
        this.loadingGenerales = true;
        this.editProfesionalesGenerales(this.generales).then(r => {
          this.loadingGenerales = false;
          if(r & this.isEstudiante){
            this.showedit = false;
          }
        });
      },
      eraseExperiencia(value){
        this.experienciaedit = (!!this.cvprofesionales.experiencia) ? this.cvprofesionales.experiencia : [];
      },
      eraseNewExperiencia(value){
        this.newexperiencias = this.newexperiencias.filter(e => e.puesto != value.puesto);
        this.newexperienciaslength--;
      },
      saveData(){

        this.clicked = true;


            if(this.experienciaedit.every(e => e.allok)  &  this.newexperiencias.every(e => e.allok)){

              this.experienciaedit = this.experienciaedit.concat(this.newexperiencias);

            if(this.experienciaedit.length != 0){

              this.loadingExperiencia = true;

              this.experienciaedit.forEach((e,key) => {
                this.editExperiencia(e).then(r => {
                  if(key+1 == this.experienciaedit.length){
                    this.showedit = false;
                    this.shownew = false;
                    this.loadingExperiencia = false;
                    this.newexperiencias = [];
                    this.newexperienciaslength = 0;
                    this.clicked = false;
                    this.requestCV();
                  }
                })
              });

            }

            }else{
              this.clicked = true;
              this.loadingExperiencia = false;
            }
    
      }
    },
    components: {
      'experiencia': experiencia,
      'experiencia-edit': experienciaedit
    },
    watch : {
      'showedit'(){
        this.experienciaedit = (!!this.cvprofesionales.experiencia) ? this.cvprofesionales.experiencia : [];
      },
      'cvprofesionales.experiencia': {
          deep: true,
          handler(){
            this.experienciaedit = (!!this.cvprofesionales.experiencia) ? this.cvprofesionales.experiencia : [];
          }
      }
    }
  }
</script>

<style lang="scss" scoped>


  .contenedor-check {
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  
  .add-btn{
    margin-bottom: 25px;
  }


</style>


// WEBPACK FOOTER //
// src/components/view-parts/espacio-personal/datos-profesionales.vue